<!--
© Copyright 2015-2026 Personalized Privacy Assistant Project, Carnegie Mellon University - All Rights Reserved - US Patent 11,768,949, US Patent 10,956,586, US Patent 12,235,973, and additional USPTO and EPO patents pending.
This code is proprietary and confidential. For any questions about this code, including licensing, please contact Prof. Norman Sadeh (sadeh@cs.cmu.edu).
-->
<template>

    <!-- My Resources Statistics Panel -->
    <div v-if="!isTemplate">
      <div class="row">
        <div class="col-12">
          <div class="card card-ui-no-border bg-color-light mb-3">
              <h3 class="font-primary font-resource pl-4 pr-4 pt-4">
                <span class="d-none d-md-block smaller float-right">
                  CREATE RESOURCE
                  <a :href="baseUrls.resourceBaseUrl + 'create'"><div class="ml-3 icon-plus-resource icon-small-offset-down"></div></a>
                </span>
                <span class="d-block d-md-none smaller float-right">
                  <div class="ml-3 icon-plus-resource icon-small-offset-down shadow-resource"></div>
                </span>
              </h3>
              <div class="row bg-color-light border-rounded-full p-2 m-3">

                <!-- inner cards -->
                <div class="col-lg-4 col-md-8 col-sm-2 pr-1 pl-1">
                  <div class="bg-color-light border-dark border-rounded-full p-2 h-100">
                    <div class="row h-100">
                      <div class="col-lg-6 col-md-12">
                        <div class="card card-ui card-ui-no-border card-solid bg-color-light h-100">
                          <div class="card-body d-flex flex-column">
                            <h1>{{resourceInfo.total}}</h1>
                            <p>TOTAL RESOURCES</p>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-12">
                        <div class="card card-ui card-ui-no-border bg-color-light h-100">
                          <table class="table table-sm table-borderless my-auto">
                            <tbody>
                              <!--
                              <tr>
                                <td>
                                  <h4 class="color-inherit mb-0">5</h4>
                                  <p class="mb-2">DRAFTS</p>
                                </td>
                              </tr>
                              -->
                              <tr>
                                <td>
                                  <h4 class="color-inherit mb-0">{{resourceInfo.numUnpublished}}</h4>
                                  <p class="mb-2">UNPUBLISHED</p>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <h4 class="color-inherit mb-0">{{resourceInfo.numPublished}}</h4>
                                  <p class="mb-2">PUBLISHED</p>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-2 col-md-4 col-sm-1 pr-1 pl-1">
                  <div class="card card-ui bg-color-light border-dark d-flex h-100">
                    <div class="card-header card-header-success">
                      <div class="icon-resource icon-success icon-offset-down shadow-resource"></div>
                    </div>
                    <div class="card-body d-flex flex-column">
                      <h3>{{resourceInfo.numPublications}}</h3>
                      <p class="small">RESOURCE PUBLICATIONS</p>
                      <a :href="baseUrls.resourceBaseUrl + 'index/published#list'" class="btn btn-resource btn-success btn-sm mt-auto">VIEW</a>
                    </div>
                  </div>
                </div>

                <div class="col-lg-2 col-md-4 col-sm-1 pr-1 pl-1">
                  <div class="card card-ui bg-color-light border-dark d-flex h-100">
                    <div v-if="resourceInfo.pendingPublishRequests > 0" class="card-header card-header-warning">
                      <div class="icon-resource icon-warning icon-offset-down shadow-resource"></div>
                    </div>
                    <div v-else class="card-header card-header-disabled">
                      <div class="icon-resource icon-disabled icon-offset-down shadow-resource"></div>
                    </div>
                    <div class="card-body d-flex flex-column">
                      <h3>{{resourceInfo.pendingPublishRequests}}</h3>
                      <p class="small">PENDING PUBLICATION REQUESTS</p>
                      <a v-if="resourceInfo.pendingPublishRequests > 0" :href="baseUrls.resourceBaseUrl + 'index/pending#list'" class="btn btn-resource btn-warning btn-sm mt-auto">VIEW</a>
                      <button v-else href="#" class="btn btn-resource btn-disabled btn-sm mt-auto" disabled>VIEW</button>
                    </div>
                  </div>
                </div>

                <div class="col-lg-2 col-md-4 col-sm-1 pr-1 pl-1">
                  <div class="card card-ui bg-color-light border-dark d-flex h-100">
                    <div v-if="resourceInfo.deniedPublishRequests > 0" class="card-header card-header-danger">
                      <div class="icon-resource icon-danger icon-offset-down shadow-resource"></div>
                    </div>
                    <div v-else class="card-header card-header-disabled">
                      <div class="icon-resource icon-disabled icon-offset-down shadow-resource"></div>
                    </div>
                    <div class="card-body d-flex flex-column">
                      <h3>{{resourceInfo.deniedPublishRequests}}</h3>
                      <p class="small">DENIED PUBLICATION REQUESTS</p>
                      <a v-if="resourceInfo.deniedPublishRequests > 0" :href="baseUrls.resourceBaseUrl + 'index/denied#list'" class="btn btn-resource btn-danger btn-sm mt-auto">VIEW</a>
                      <button v-else href="#" class="btn btn-resource btn-disabled btn-sm mt-auto" disabled>VIEW</button>
                    </div>
                  </div>
                </div>

                <div class="col-lg-2 col-md-4 col-sm-1 pr-1 pl-1">
                  <div class="card card-ui bg-color-light border-dark d-flex h-100">
                    <div class="card-header card-header-disabled">
                      <div class="icon-resource icon-disabled icon-offset-down shadow-resource"></div>
                    </div>
                    <div class="card-body d-flex flex-column">
                      <h3>0</h3>
                      <p class="small">TAKEN DOWN PUBLICATIONS</p>
                      <button class="btn btn-resource btn-disabled btn-sm mt-auto" disabled>VIEW</button>
                    </div>
                  </div>
                </div>

              </div>  <!-- end outer row - my resources -->
          </div>  <!-- end outer card - my resources -->
        </div>  <!-- end outer column - my resources -->
      </div> <!-- end row -->
    </div> <!-- end v-if -->


    <div v-else>
      <div class="row">
        <div class="col-12">
          <h3 class="font-primary font-template pl-4 pr-4 pt-4">
            <span class="d-none d-md-block smaller float-right">
              CREATE TEMPLATE
              <a :href="baseUrls.templateBaseUrl + 'create'"><div class="ml-3 icon-plus-template icon-small-offset-down"></div></a>
            </span>
            <span class="d-block d-md-none smaller float-right">
              <div class="ml-3 icon-plus-template icon-small-offset-down shadow-resource"></div>
            </span>
          </h3>
        </div>  <!-- end outer column - my templates -->
      </div> <!-- end row -->
    </div>



</template>

<script>
    export default {
      props: {
        existingData: [Object, Array],
        isTemplate: [Boolean, Number],
        resourceInfo: Object,
        templateInfo: Object,
      },
      mounted(){
        //
      },
      data() {
        return {
          numResourcesPublished: 0,
          numResourcesUnpublished: 0,
          numTemplatesPublic: 0,
          numTemplatesPrivate: 0,
          baseUrls: {
            resourceBaseUrl: '/resource/',
            irrBaseUrl: '/irr/',
            irrRequestBaseUrl: '/irr-request/',
            templateBaseUrl: '/template/',
            userBaseUrl: '/user/'
          },
        }
      },
      mounted: function () {
        //get the published/unpublished counts for resources
        //get the public/private counts for templates
        for(var i=0; i<this.existingData.length; i++ ) {

          if(!this.existingData[i].is_template) {
            var isPublished = false; //if the resource is published in at least one IRR
            for(var j=0; j<this.existingData[i].associatedIrrs.length; j++) {
              if(this.existingData[i].associatedIrrs[j].resourceState == 'Published') {
                isPublished = true;
                this.numResourcesPublished++;
              }
            }
            if(!isPublished) {
              this.numResourcesUnpublished++;
            }
          }
          else {
            if(this.existingData[i].template_public) {
              this.numTemplatesPublic++;
            } else {
              this.numTemplatesPrivate++;
            }

          }

        }
      },
    }
</script>
